import React from "react";
import { withTranslation } from "react-i18next";
import FileAssignmentDialog from "./tabs/fileUploadTab/FileAssignmentDialog";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../../../helpers/APIErrorHelper";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

class AssignExaminationManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      studentExaminationFiles: [],
      dialogApiError: "",
    };

    this.handleHide = this.handleHide.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  async handleUpload(files) {
    for (const idx in files) {
      try {
        const x = await CamplaCoreService.uploadStudentExamFiles(
          this.props.examinationId,
          files[idx],
          this.props.searchObject
        );

        const updated = x.map((el) => ({
          ...el,
          status: el.instance ? 1 : 2,
        }));

        this.setState((prev) => ({
          studentExaminationFiles: [
            ...prev.studentExaminationFiles,
            ...updated,
          ],
        }));
      } catch (err) {
        this.setState({
          dialogApiError: APIErrorHelper.getError(
            err,
            () => this.setState({ dialogApiError: "" }),
            {
              PRECONDITION_FAILED:
                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.PreconditionFailed",
              NOT_FOUND:
                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.NotFound",
              BAD_REQUEST:
                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.BadRequest",
              CONFLICT:
                "SingleExamination.InstanceTab.StudentExaminationFilesDialog.APIError.Conflict",
            },
            this.props.t
          ),
        });
      }
    }
  }

  handleHide() {
    this.props.onHide();
    this.setState({ studentExaminationFiles: [] });
  }

  humanReadableFileSize = (size) => {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  };

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.handleHide}
        title={t("SingleExamination.InstanceTab.FileAssignmentDialog.Title")}
        leftButtonText={t("DialogClose")}
        leftButtonVariant="black"
        leftButtonCallback={this.handleHide}
        body={
          <FileAssignmentDialog
            examination={this.props.examination}
            searchObject={this.props.searchObject}
            onChangeSearchObj={this.props.onChangeSearchObj}
            instanceTemplate={this.props.instanceTemplate}
            studentExaminationFiles={this.state.studentExaminationFiles}
            onUpload={this.handleUpload}
            onDelete={this.handleDelete}
          />
        }
      />
    );
  }
}

export default withTranslation()(AssignExaminationManager);
